import React from 'react'
import { Box, Button, Heading, useDisclosure, HStack, Tooltip, Flex, Divider } from '@chakra-ui/react'
import { FiFileText, FiDownload, FiPieChart } from 'react-icons/fi'
import { AcompanhamentoApasProvider, useAcompanhamentoApas } from './hooks/AcompanhamentoApasContext'
import { TabelaAcompanhamentoApas } from './components/TabelaAcompanhamentoApas'
import { ModalSumarioAcompanhamentoApas } from './components/ModalSumarioAcompanhamentoApas'
import { HeadingPages } from '../../../components/HeadingPages'

const BotoesExportacao = () => {
  const { exportarPDF, exportarExcel, pdfLoading, excelLoading } = useAcompanhamentoApas()

  return (
    <HStack>
      <Button leftIcon={<FiDownload />} colorScheme="green" onClick={exportarExcel} isLoading={excelLoading}>
        Exportar Excel
      </Button>
      <Button leftIcon={<FiFileText />} colorScheme="red" onClick={exportarPDF} isLoading={pdfLoading}>
        Exportar PDF
      </Button>
    </HStack>
  )
}

const AcompanhamentoApasContent = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box p={5} maxW="100%" overflow="hidden">
      <HStack justifyContent="space-between" mb={4}>
        <Heading size="md">Acompanhamento de Clientes APAS</Heading>
        <HStack>
          <BotoesExportacao />
          <Button leftIcon={<FiPieChart />} colorScheme="blue" onClick={onOpen}>
            Sumário de Clientes
          </Button>
        </HStack>
      </HStack>

      <Box borderRadius="md" overflow="hidden" boxShadow="sm">
        <TabelaAcompanhamentoApas />
      </Box>

      <ModalSumarioAcompanhamentoApas isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}

const AcompanhamentoApas = () => {
  return (
    <>
      <HeadingPages name={'Acompanhamento APAS'} />
      <AcompanhamentoApasProvider>
        <AcompanhamentoApasContent />
      </AcompanhamentoApasProvider>
    </>
  )
}

export default AcompanhamentoApas
